import styled, { css } from 'styled-components';
import LinkHandler from '../link-handler';
import { focusStyles } from './focus';

export const linkStyles = css`
  color: ${({ theme }) => theme.palette.link};
  text-decoration: underline;

  // duplicate hover 1 rule to style inside header
  &:focus,
  &:hover {
    color: ${({ theme }) => theme.palette.primaryLinkHover};
  }

  &:focus {
    ${focusStyles}
  }

  main & {
    &:visited {
      color: ${({ theme }) => theme.palette.linkVisited};
    }
    // duplicate hover rule 2 to style content with extra specificity
    &:focus,
    &:hover {
      color: ${({ theme }) => theme.palette.primaryLinkHover};
    }
  }
`;

export const linkOnDarkBgStyles = css`
  ${linkStyles};
  color: ${({ theme }) => theme.palette.white};

  main & {
    &:visited {
      color: ${({ theme }) => theme.palette.linkVisitedOnDarkBG};
    }
    &:focus,
    &:hover {
      color: ${({ theme }) => theme.palette.linkHoverOnDarkBG};
    }
  }
`;

export const CoveringLink = styled(LinkHandler)`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
`;
